export default function getMediaUrl(baseUrl, mediaUrl) {
    if(!mediaUrl){
        return undefined;
    }
    if (mediaUrl.match(/^https?:\/\//)) {
        return mediaUrl
    }
    return `${baseUrl}${mediaUrl}`
}